export const currencyFilter = function (value: number, symbol: string): string {
  const formatter = new Intl.NumberFormat("en-AU", {
    minimumFractionDigits: 2,
  });
  return symbol + formatter.format(value);
};
